import {defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {bundleConstants, uriConstants} from "../../constants";

export const bundleActions = {
  readBundleList,
  selectBundleInfo,
  changeSearchInfo,
  getBundleInfo,
  settingHistory,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 꾸러미 신청 목록 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: bundleConstants.SELECT_SEARCH_REQUEST,
      payload: info
    }
  }
}


/*********
 꾸러미 신청 목록 조회
 **********/

function readBundleList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_BUNDLE_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(alertActions.error({
            title: null,
            message: errorMessages.systemError
          }))
        }
      )
  }

  function request() {
    return {
      type: bundleConstants.BUNDLE_REQUEST
    }
  }
  function success(response) {
    return {
      type: bundleConstants.BUNDLE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: bundleConstants.BUNDLE_FAILURE,
      response
    }
  }
}

/***********
 꾸러미 신청 상세 선택
 ************/
function selectBundleInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: bundleConstants.SELECT_REQUEST,
      payload: info
    }
  }
}

/*********
 꾸러미 신청 상세조회
 **********/

function getBundleInfo(packageId) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_BUNDLE_INFO + "/" + packageId
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: bundleConstants.DETAIL_REQUEST
    }
  }
  function success(response) {
    return {
      type: bundleConstants.DETAIL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: bundleConstants.DETAIL_FAILURE,
      response
    }
  }
}

/***********
 꾸러미 신청 히스토리관리
 ************/
function settingHistory(history) {
  return async dispatch => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: bundleConstants.BUNDLE_HISTORY,
      payload: history
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

